import { render, staticRenderFns } from "./ia-cliente-cabecalho.vue?vue&type=template&id=bb3d02fe&scoped=true&"
import script from "./ia-cliente-cabecalho.vue?vue&type=script&lang=js&"
export * from "./ia-cliente-cabecalho.vue?vue&type=script&lang=js&"
import style0 from "./ia-cliente-cabecalho.vue?vue&type=style&index=0&id=bb3d02fe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3d02fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb3d02fe')) {
      api.createRecord('bb3d02fe', component.options)
    } else {
      api.reload('bb3d02fe', component.options)
    }
    module.hot.accept("./ia-cliente-cabecalho.vue?vue&type=template&id=bb3d02fe&scoped=true&", function () {
      api.rerender('bb3d02fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/ia-cliente-painel/ia-cliente-cabecalho.vue"
export default component.exports